import { ContextType } from "../misc";
import { useMetadataAndProviderLoader } from "./useProviderInfoPage";

export const useProviderComparePage = (fromAdminId?: string, toAdminId?: string) => {
    const { metadata, provider, loading, metadataLoading } = useMetadataAndProviderLoader(fromAdminId);
    const { provider: toProvider, loading: toProviderLoading } = useMetadataAndProviderLoader(toAdminId);
    const contextType: ContextType = "comparison";
    return { metadata, provider, toProvider, loading, toProviderLoading, metadataLoading, contextType };
};
